import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDialogAccount, LazyDialogCommunitySlider, LazyDialogFilters, LazyDialogFrequentlyAskedQuestions, LazyDialogHotspotShop, LazyDialogMegaMenu, LazyDialogPartners, LazyDialogQuickshop, LazyDialogSearchHub, LazyDialogSheerId, LazyCmsBloomreachRecommendations, LazyCmsEventCollection, LazyCmsProductRecommendationsStandard, LazyCmsPromoBar, LazyCmsPromoBarMessage, LazyCmsRecommendationCarousel, LazyDialogMiniCart, LazyCmsAccordions, LazyCmsAnchor, LazyCmsArticleCarousel, LazyCmsArticleGridV2, LazyCmsArticleGrid, LazyCmsBannerBlockBelow, LazyCmsBannerEspot, LazyCmsBannerImage, LazyCmsBannerImageStandard, LazyCmsBannerMenu, LazyCmsBannerOverlay, LazyCmsBannerSplit, LazyCmsBannerThin, LazyCmsBaseCaption, LazyCmsBaseEyebrow, LazyCmsBaseGradient, LazyCmsBaseResponsiveMedia, LazyCmsBenefitBar, LazyCmsCategoryCard, LazyCmsCollection, LazyCmsCollectionParallax, LazyCmsCollectionStandard, LazyCmsCollectionVerticalList, LazyCmsCtaButtonCollection, LazyCmsCtaButton, LazyCmsDialog, LazyCmsDialogGeneric, LazyCmsExperience, LazyCmsExperiment, LazyCmsFilterBy, LazyCmsFooterItem, LazyCmsHero, LazyCmsHeroBlockBelow, LazyCmsHeroProductOverlay, LazyCmsHeroStandard, LazyCmsIconAndTextCollection, LazyCmsInlineCatalogGrid, LazyCmsLayoutArticleV2, LazyCmsLayoutArticle, LazyCmsLinkedCard, LazyCmsMegaMenu, LazyCmsMegaMenuL1, LazyCmsMegaMenuL1Desktop, LazyCmsMegaMenuL1Mobile, LazyCmsMegaMenuL2, LazyCmsMegaMenuL2Desktop, LazyCmsMegaMenuL2Mobile, LazyCmsMegaMenuL3, LazyCmsMegaMenuL3Desktop, LazyCmsMegaMenuL3Mobile, LazyCmsMegaMenuMobile, LazyCmsMegaMenuVisualSelector, LazyCmsMultiLinkCard, LazyCmsParallax, LazyCmsParallaxGallery, LazyCmsPicture, LazyCmsPopUp, LazyCmsPopUpManager, LazyCmsProductRecommendations, LazyCmsProductUpsell, LazyCmsRichText, LazyCmsSecondaryNav, LazyCmsSectionPositionProvider, LazyCmsSection, LazyCmsSegmentation, LazyCmsSharedButton, LazyCmsSharedButtons, LazyCmsSharedMedia, LazyCmsSharedMegaMenuCategoryLink, LazyCmsShopTheLookGallery, LazyCmsShopTheLookMosaic, LazyCmsShowcaseControls, LazyCmsShowcaseFrame, LazyCmsShowcaseViewer, LazyCmsSpacer, LazyCmsUgc, LazyCmsUgcCuralate, LazyCmsUgcOlapic, LazyCmsUgcSocialNative, LazyCmsUgcSocialNativeMasonry, LazyCmsVideoPlayer, LazyCmsVideoCloudinaryPlayer, LazyCmsVideo, LazyDialogContent, LazyDialogPromoBar, LazyDialogSocialNativeContent, LazyDialogSocialNativeReport, LazyDialogSocialNative, LazyDialogAddGiftOption, LazyDialogAddCreditCard, LazyDialogAddYourPhoto, LazyDialogAskQuestion, LazyDialogAskQuestionSuccess, LazyDialogBarcode, LazyDialogBopisStoreSearch, LazyDialogCartChangeShippingMethod, LazyDialogCartItemActionMenu, LazyDialogCartValidateShippingAddress, LazyDialogChangeStoreConfirmation, LazyDialogCreditedConsumerTerms, LazyDialogDeleteAddress, LazyDialogDeleteCard, LazyDialogEmployeeTerms, LazyDialogForgotPassword, LazyDialogInterests, LazyDialogKlarna, LazyDialogLocationConfirmation, LazyDialogLoyaltyRedeem, LazyDialogLoyaltySignUp, LazyDialogMarketingEnrollment, LazyDialogNotifyMe, LazyDialogPayconiq, LazyDialogPickupInStore, LazyDialogProductDetailCard, LazyDialogReportIssue, LazyDialogReviewUgc, LazyDialogReviewWrite, LazyDialogReviews, LazyDialogShareYourFavorites, LazyDialogShippingAddress, LazyDialogShopTheLook, LazyDialogSignInAmazonSignOut, LazyDialogSignIn, LazyDialogSignInConfirmation, LazyDialogSignUp, LazyDialogSimplifiedEnrollment, LazyDialogSizeChart, LazyDialogStoreChanged, LazyDialogTermsAndConditions, LazyDialogThreeDsChallenge, LazyDialogTryItOn, LazyDialogVariantSelection, LazyDialogVideo, LazyDialogWelcome, LazyDialogYoutube } from '#components'
const lazyGlobalComponents = [
  ["DialogAccount", LazyDialogAccount],
["DialogCommunitySlider", LazyDialogCommunitySlider],
["DialogFilters", LazyDialogFilters],
["DialogFrequentlyAskedQuestions", LazyDialogFrequentlyAskedQuestions],
["DialogHotspotShop", LazyDialogHotspotShop],
["DialogMegaMenu", LazyDialogMegaMenu],
["DialogPartners", LazyDialogPartners],
["DialogQuickshop", LazyDialogQuickshop],
["DialogSearchHub", LazyDialogSearchHub],
["DialogSheerId", LazyDialogSheerId],
["CmsBloomreachRecommendations", LazyCmsBloomreachRecommendations],
["CmsEventCollection", LazyCmsEventCollection],
["CmsProductRecommendationsStandard", LazyCmsProductRecommendationsStandard],
["CmsPromoBar", LazyCmsPromoBar],
["CmsPromoBarMessage", LazyCmsPromoBarMessage],
["CmsRecommendationCarousel", LazyCmsRecommendationCarousel],
["DialogMiniCart", LazyDialogMiniCart],
["CmsAccordions", LazyCmsAccordions],
["CmsAnchor", LazyCmsAnchor],
["CmsArticleCarousel", LazyCmsArticleCarousel],
["CmsArticleGridV2", LazyCmsArticleGridV2],
["CmsArticleGrid", LazyCmsArticleGrid],
["CmsBannerBlockBelow", LazyCmsBannerBlockBelow],
["CmsBannerEspot", LazyCmsBannerEspot],
["CmsBannerImage", LazyCmsBannerImage],
["CmsBannerImageStandard", LazyCmsBannerImageStandard],
["CmsBannerMenu", LazyCmsBannerMenu],
["CmsBannerOverlay", LazyCmsBannerOverlay],
["CmsBannerSplit", LazyCmsBannerSplit],
["CmsBannerThin", LazyCmsBannerThin],
["CmsBaseCaption", LazyCmsBaseCaption],
["CmsBaseEyebrow", LazyCmsBaseEyebrow],
["CmsBaseGradient", LazyCmsBaseGradient],
["CmsBaseResponsiveMedia", LazyCmsBaseResponsiveMedia],
["CmsBenefitBar", LazyCmsBenefitBar],
["CmsCategoryCard", LazyCmsCategoryCard],
["CmsCollection", LazyCmsCollection],
["CmsCollectionParallax", LazyCmsCollectionParallax],
["CmsCollectionStandard", LazyCmsCollectionStandard],
["CmsCollectionVerticalList", LazyCmsCollectionVerticalList],
["CmsCtaButtonCollection", LazyCmsCtaButtonCollection],
["CmsCtaButton", LazyCmsCtaButton],
["CmsDialog", LazyCmsDialog],
["CmsDialogGeneric", LazyCmsDialogGeneric],
["CmsExperience", LazyCmsExperience],
["CmsExperiment", LazyCmsExperiment],
["CmsFilterBy", LazyCmsFilterBy],
["CmsFooterItem", LazyCmsFooterItem],
["CmsHero", LazyCmsHero],
["CmsHeroBlockBelow", LazyCmsHeroBlockBelow],
["CmsHeroProductOverlay", LazyCmsHeroProductOverlay],
["CmsHeroStandard", LazyCmsHeroStandard],
["CmsIconAndTextCollection", LazyCmsIconAndTextCollection],
["CmsInlineCatalogGrid", LazyCmsInlineCatalogGrid],
["CmsLayoutArticleV2", LazyCmsLayoutArticleV2],
["CmsLayoutArticle", LazyCmsLayoutArticle],
["CmsLinkedCard", LazyCmsLinkedCard],
["CmsMegaMenu", LazyCmsMegaMenu],
["CmsMegaMenuL1", LazyCmsMegaMenuL1],
["CmsMegaMenuL1Desktop", LazyCmsMegaMenuL1Desktop],
["CmsMegaMenuL1Mobile", LazyCmsMegaMenuL1Mobile],
["CmsMegaMenuL2", LazyCmsMegaMenuL2],
["CmsMegaMenuL2Desktop", LazyCmsMegaMenuL2Desktop],
["CmsMegaMenuL2Mobile", LazyCmsMegaMenuL2Mobile],
["CmsMegaMenuL3", LazyCmsMegaMenuL3],
["CmsMegaMenuL3Desktop", LazyCmsMegaMenuL3Desktop],
["CmsMegaMenuL3Mobile", LazyCmsMegaMenuL3Mobile],
["CmsMegaMenuMobile", LazyCmsMegaMenuMobile],
["CmsMegaMenuVisualSelector", LazyCmsMegaMenuVisualSelector],
["CmsMultiLinkCard", LazyCmsMultiLinkCard],
["CmsParallax", LazyCmsParallax],
["CmsParallaxGallery", LazyCmsParallaxGallery],
["CmsPicture", LazyCmsPicture],
["CmsPopUp", LazyCmsPopUp],
["CmsPopUpManager", LazyCmsPopUpManager],
["CmsProductRecommendations", LazyCmsProductRecommendations],
["CmsProductUpsell", LazyCmsProductUpsell],
["CmsRichText", LazyCmsRichText],
["CmsSecondaryNav", LazyCmsSecondaryNav],
["CmsSectionPositionProvider", LazyCmsSectionPositionProvider],
["CmsSection", LazyCmsSection],
["CmsSegmentation", LazyCmsSegmentation],
["CmsSharedButton", LazyCmsSharedButton],
["CmsSharedButtons", LazyCmsSharedButtons],
["CmsSharedMedia", LazyCmsSharedMedia],
["CmsSharedMegaMenuCategoryLink", LazyCmsSharedMegaMenuCategoryLink],
["CmsShopTheLookGallery", LazyCmsShopTheLookGallery],
["CmsShopTheLookMosaic", LazyCmsShopTheLookMosaic],
["CmsShowcaseControls", LazyCmsShowcaseControls],
["CmsShowcaseFrame", LazyCmsShowcaseFrame],
["CmsShowcaseViewer", LazyCmsShowcaseViewer],
["CmsSpacer", LazyCmsSpacer],
["CmsUgc", LazyCmsUgc],
["CmsUgcCuralate", LazyCmsUgcCuralate],
["CmsUgcOlapic", LazyCmsUgcOlapic],
["CmsUgcSocialNative", LazyCmsUgcSocialNative],
["CmsUgcSocialNativeMasonry", LazyCmsUgcSocialNativeMasonry],
["CmsVideoPlayer", LazyCmsVideoPlayer],
["CmsVideoCloudinaryPlayer", LazyCmsVideoCloudinaryPlayer],
["CmsVideo", LazyCmsVideo],
["DialogContent", LazyDialogContent],
["DialogPromoBar", LazyDialogPromoBar],
["DialogSocialNativeContent", LazyDialogSocialNativeContent],
["DialogSocialNativeReport", LazyDialogSocialNativeReport],
["DialogSocialNative", LazyDialogSocialNative],
["DialogAddGiftOption", LazyDialogAddGiftOption],
["DialogAddCreditCard", LazyDialogAddCreditCard],
["DialogAddYourPhoto", LazyDialogAddYourPhoto],
["DialogAskQuestion", LazyDialogAskQuestion],
["DialogAskQuestionSuccess", LazyDialogAskQuestionSuccess],
["DialogBarcode", LazyDialogBarcode],
["DialogBopisStoreSearch", LazyDialogBopisStoreSearch],
["DialogCartChangeShippingMethod", LazyDialogCartChangeShippingMethod],
["DialogCartItemActionMenu", LazyDialogCartItemActionMenu],
["DialogCartValidateShippingAddress", LazyDialogCartValidateShippingAddress],
["DialogChangeStoreConfirmation", LazyDialogChangeStoreConfirmation],
["DialogCreditedConsumerTerms", LazyDialogCreditedConsumerTerms],
["DialogDeleteAddress", LazyDialogDeleteAddress],
["DialogDeleteCard", LazyDialogDeleteCard],
["DialogEmployeeTerms", LazyDialogEmployeeTerms],
["DialogForgotPassword", LazyDialogForgotPassword],
["DialogInterests", LazyDialogInterests],
["DialogKlarna", LazyDialogKlarna],
["DialogLocationConfirmation", LazyDialogLocationConfirmation],
["DialogLoyaltyRedeem", LazyDialogLoyaltyRedeem],
["DialogLoyaltySignUp", LazyDialogLoyaltySignUp],
["DialogMarketingEnrollment", LazyDialogMarketingEnrollment],
["DialogNotifyMe", LazyDialogNotifyMe],
["DialogPayconiq", LazyDialogPayconiq],
["DialogPickupInStore", LazyDialogPickupInStore],
["DialogProductDetailCard", LazyDialogProductDetailCard],
["DialogReportIssue", LazyDialogReportIssue],
["DialogReviewUgc", LazyDialogReviewUgc],
["DialogReviewWrite", LazyDialogReviewWrite],
["DialogReviews", LazyDialogReviews],
["DialogShareYourFavorites", LazyDialogShareYourFavorites],
["DialogShippingAddress", LazyDialogShippingAddress],
["DialogShopTheLook", LazyDialogShopTheLook],
["DialogSignInAmazonSignOut", LazyDialogSignInAmazonSignOut],
["DialogSignIn", LazyDialogSignIn],
["DialogSignInConfirmation", LazyDialogSignInConfirmation],
["DialogSignUp", LazyDialogSignUp],
["DialogSimplifiedEnrollment", LazyDialogSimplifiedEnrollment],
["DialogSizeChart", LazyDialogSizeChart],
["DialogStoreChanged", LazyDialogStoreChanged],
["DialogTermsAndConditions", LazyDialogTermsAndConditions],
["DialogThreeDsChallenge", LazyDialogThreeDsChallenge],
["DialogTryItOn", LazyDialogTryItOn],
["DialogVariantSelection", LazyDialogVariantSelection],
["DialogVideo", LazyDialogVideo],
["DialogWelcome", LazyDialogWelcome],
["DialogYoutube", LazyDialogYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
